import React, { useEffect, useState } from 'react';
import SEO from '../components/SEO';
import JobsBoardHeroSection from '../components/jobs/JobsBoardHeroSection';
import JobsOpenRolesSection from '../components/jobs/JobsOpenRolesSection';
import JobsDirectionCtaSection from '../components/jobs/JobsDirectionCtaSection';

function Jobs() {
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);

  useEffect(() => {
    if (!toastMessage) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setToastMessage('');
    }, 3500);

    return () => window.clearTimeout(timeoutId);
  }, [toastMessage]);

  const handleApplySuccess = () => {
    setToastMessage('Application submitted successfully. We will contact you soon.');
  };

  return (
    <main style={{ background: '#14202B', color: '#E8EEF3', minHeight: '100vh' }}>
      <SEO
        title="Jobs | Lead With Tech"
        description="Explore open roles and opportunities at Lead With Tech."
      />

      {toastMessage ? (
        <div
          role="status"
          aria-live="polite"
          style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 1400,
            background: '#17663a',
            color: '#E9FFF3',
            border: '1px solid #2d8a55',
            borderRadius: '10px',
            boxShadow: '0 12px 26px rgba(0, 0, 0, 0.22)',
            padding: '12px 14px',
            fontSize: '0.92rem',
            fontWeight: 700,
            maxWidth: '420px',
          }}
        >
          {toastMessage}
        </div>
      ) : null}

      <JobsBoardHeroSection />
      <JobsOpenRolesSection onApplySuccess={handleApplySuccess} />
      <JobsDirectionCtaSection />
    </main>
  );
}

export default Jobs;
